import { Injectable } from "@angular/core";
import { Subject } from "rxjs";

@Injectable()
export class BfxMultiSelectorService {
  protected _filterSelection: string;
  protected keyBoardEvent = new Subject<any>();
  public keyDownObservable$ = this.keyBoardEvent.asObservable();

  set filterSelection(filterSelection: string) {
    this._filterSelection = filterSelection;
  }

  get filterSelection(): string {
    return this._filterSelection;
  }

  public passKeyDownEven(event: any) {
    if (event) this.keyBoardEvent.next(event);
  }
}
